<template>
  <div id="app">
      <div class="d-header">Encoding in Short-Term Memory</div>
      <progress class="d-progress" :value="progressCnt" :max="progressMax"></progress>
      <div class="d-cont">
          <div class="body">
              <div v-if="showDBox" class="d-box">
                <div class="body">
                    <div class="content" v-if="progressCnt == 0 || progressCnt == 23">
                        <h1 v-if="progressCnt == 0">Encoding in Short-Term Memory</h1>
                        
                        <div v-if="progressCnt == 23"><h3>You have completed this exercise</h3><br>Thank you for participating</div>
                    </div>
                    <div class="content" v-if="progressCnt == 4">
                        <p class="text-left">You are about to listen to a sequence of words.</p>
                        <p class="text-left">You will then be asked to recall them (the trial will repeat four times).</p>
                        <p class="text-left">Please do not write the words down or use any other device to recall them, otherwise, you might not understand the purpose of the experiment.</p>
                        <p class="text-left">Click the TEST button to check sound volume. Adjust the sound volume accordingly. If you are in a class, you may need to wear headphones.</p>
                        <div><button class="btn" @click="btnTest"><strong> TEST </strong></button></div>
                        <p class="text-left">Click NEXT to continue.</p>
                    </div>
                    <div class="content con-listen" v-if="progressCnt == 5 || progressCnt == 7 || progressCnt == 9 || progressCnt == 11">
                        <div ><strong>{{listenCarefully}}</strong></div>
                    </div>
                    <div class="content" v-if="progressCnt == 6">
                        <p class="text-left">Please type the words you just heard in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> that you heard them.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <span><input type="text" class="my-textbox" v-model="similarDataAudio[0]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[1]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[2]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[3]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[4]"> </span>
                    </div>
                    <div class="content" v-if="progressCnt == 8">
                        <p class="text-left">Please type the words you just heard in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> that you heard them.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <span><input type="text" class="my-textbox" v-model="differenceDataAudio[0]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[1]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[2]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[3]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[4]"> </span>
                    </div>
                    <div class="content" v-if="progressCnt == 10">
                        <p class="text-left">Please type the words you just heard in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> that you heard them.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <span><input type="text" class="my-textbox" v-model="similarDataAudio[5]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[6]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[7]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[8]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="similarDataAudio[9]"> </span>
                    </div>
                    <div class="content" v-if="progressCnt == 12">
                        <p class="text-left">Please type the words you just heard in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> that you heard them.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[5]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[6]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[7]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[8]"> </span>
                        <span><input type="text" class="my-textbox mt-2" v-model="differenceDataAudio[9]"> </span>
                    </div>
                    <div class="content" v-if="progressCnt == 13">
                        <p class="text-left">You will now be shown a series of five words.</p>
                        <p class="text-left">You will then be asked to recall them.</p>
                        <p class="text-left">(This trial will again repeat four times.)</p>
                    </div>
                    <div class="content con-listen" v-if="progressCnt == 14">
                        <div>
                          <div class="mb-3"><strong>cad</strong></div>
                          <div class="mb-3"><strong>cap</strong></div>
                          <div class="mb-3"><strong>cab</strong></div>
                          <div class="mb-3"><strong>can</strong></div>
                          <div><strong>max</strong></div>
                        </div>
                    </div>
                    <div class="content con-listen" v-if="progressCnt == 16">
                        <div>
                          <div class="mb-3"><strong>pit</strong></div>
                          <div class="mb-3"><strong>few</strong></div>
                          <div class="mb-3"><strong>bar</strong></div>
                          <div class="mb-3"><strong>cow</strong></div>
                          <div><strong>sup</strong></div>
                        </div>
                    </div>
                    <div class="content con-listen" v-if="progressCnt == 18">
                        <div>
                          <div class="mb-3"><strong>cad</strong></div>
                          <div class="mb-3"><strong>map</strong></div>
                          <div class="mb-3"><strong>max</strong></div>
                          <div class="mb-3"><strong>cab</strong></div>
                          <div><strong>can</strong></div>
                        </div>
                    </div>
                    <div class="content con-listen" v-if="progressCnt == 20">
                        <div>
                          <div class="mb-3"><strong>rig</strong></div>
                          <div class="mb-3"><strong>few</strong></div>
                          <div class="mb-3"><strong>hot</strong></div>
                          <div class="mb-3"><strong>pen</strong></div>
                          <div><strong>pit</strong></div>
                        </div>
                    </div>
                    <div class="content" v-if="progressCnt == 15">
                        <p class="text-left">Please enter the words you just saw in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> as displayed on the previous screen.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[0]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[1]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[2]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[3]"> </div>
                        <div><input type="text" class="my-textbox mt-3 mb-3" v-model="similarDataVisual[4]"> </div>
                    </div>
                    <div class="content" v-if="progressCnt == 17">
                        <p class="text-left">Please enter the words you just saw in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> as displayed on the previous screen.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[0]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[1]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[2]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[3]"> </div>
                        <div><input type="text" class="my-textbox mt-3 mb-3" v-model="differenceDataVisual[4]"> </div>
                    </div>
                    <div class="content" v-if="progressCnt == 19">
                        <p class="text-left">Please enter the words you just saw in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> as displayed on the previous screen.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[5]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[6]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[7]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="similarDataVisual[8]"> </div>
                        <div><input type="text" class="my-textbox mt-3 mb-3" v-model="similarDataVisual[9]"> </div>
                    </div>
                    <div class="content" v-if="progressCnt == 21">
                        <p class="text-left">Please enter the words you just saw in the boxes below.</p>
                        <p class="text-left">Type them in the <strong>same order</strong> as displayed on the previous screen.</p>
                        <p class="text-left">(If you are using a desktop computer, press TAB to move to the next box. If you are using a mobile or touchscreen device, tap the boxes to insert text)</p>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[5]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[6]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[7]"> </div>
                        <div><input type="text" class="my-textbox mt-3" v-model="differenceDataVisual[8]"> </div>
                        <div><input type="text" class="my-textbox mt-3 mb-3" v-model="differenceDataVisual[9]"> </div>
                    </div>
                    <div class="content" v-if="progressCnt == 22">
                        <div class="row">
                            <div class="col-md-6 text-left">
                                <p><strong>Your Results</strong></p>
                                <p>Hover the cursor over the bars to see the exact values</p>
                            </div>
                            <div class="col-md-5">
                                <div>
                                  <bar-chart :chartData="datacollection" :maxScore="maxScore" :height="200"></bar-chart>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <!-- <p class="text-left">Baddeley&rsquo;s results were:</p> -->
                                <p class="text-left" style="text-indent:50px;">Baddeley&rsquo;s results found an 82.1% correct recall for dissimilar items but only 9.6% correct for acoustically similar words. Similar results were found with visual presentation. The most common type of error that participants make is confusing similar words in the list, such as:</p>
                                <ul>
                                  <li class="text-left">forgetting their order</li>
                                  <li class="text-left">being unable to remember one of the similar words</li>
                                </ul>
                                <p class="text-left">Baddeley (1968) concluded that these errors demonstrate the importance of<br />phonological encoding in short-term memory.</p>
                            </div>
                        </div>

                    </div>

                    <div class="footer">
                        <button v-if="progressCnt != 0" class="btn btn-target float-left" @click="btnGameBack" :disabled="!btnShow" >BACK</button>
                        <button class="btn" @click="btnBox" :disabled="!btnShow">{{boxBtnText}}</button>
                    </div>
                </div>
              </div>
              <div v-if="showDGame" class="d-game">
                  <div class="body" v-if="progressCnt == 1">
                      <div class="header">Encoding in Short-Term Memory</div>
                      <div class="target">
                          <p>Encoding concerns how something gets into short-term memory in the first place.</p>
                          <p>Suppose someone you are attracted to gives you their telephone number and you have to remember it without the aid of a pen or any other device.</p>
                          <p>What are the chances that you will be able to recall it 1 hour later?</p>
                          
                          <p>
                            <em>Please select one option.</em>
                            <div style="margin-bottom: -12px;"><input type="checkbox" id="PrettyHigh" class="mr-2" v-model="checkbox1[0]" @change="checkbox1[0] == true ? checkbox1[1] = false : checkbox1[0] = false"> <label for="PrettyHigh">Pretty high</label></div>
                            <div><input type="checkbox" id="PrettyLow" class="mr-2" v-model="checkbox1[1]" @change="checkbox1[1] == true ? checkbox1[0] = false : checkbox1[1] = false"> <label for="PrettyLow">Pretty low</label></div>
                          </p>

                          <p>Suppose you have to remember a phone number on behalf of someone else in your household (with a pen or other device).</p>
                          <p>What are the chances that you will be able to recall it 1 hour later?</p>
                          
                          <p>
                            <em>Please select one option.</em>
                            <div style="margin-bottom: -12px;"><input type="checkbox" id="PrettyHigh2" class="mr-2"  v-model="checkbox2[0]" @change="checkbox2[0] == true ? checkbox2[1] = false : checkbox2[0] = false"> <label for="PrettyHigh2">Pretty high</label></div>
                            <div><input type="checkbox" id="PrettyLow2" class="mr-2" v-model="checkbox2[1]" @change="checkbox2[1] == true ? checkbox2[0] = false : checkbox2[1] = false"> <label for="PrettyLow2">Pretty low</label></div>
                          </p>

                      </div>
                      <div class="footer">
                          <button class="btn btn-target float-left" @click="btnGameBack">BACK</button>
                          <button class="btn btn-target" @click="btnGame">NEXT</button>
                      </div>
                  </div>
                  <div class="body" v-if="progressCnt == 2">
                      <div class="header" >{{confident}}</div>
                      <div class="target">
                          <p>Most people say that the chances of remembering an important telephone number are pretty high, and the chances of remembering a not-so important number (well, at least for them) are pretty low.</p>
                          <p>Clearly, the ability to remember is based on how important the information is to us personally.</p>
                          <p>However, there are factors that determine whether or not something can be remembered.</p>
                          <p>In terms of recalling words, one important factor is the type of words used, as we will see in an experiment designed by Alan Baddeley in the 1960s (Baddeley, 1966).</p>
                      </div>
                      <div class="footer">
                          <button class="btn btn-target float-left" @click="btnGameBack">BACK</button>
                          <button class="btn btn-target" @click="btnGame">NEXT</button>
                      </div>
                  </div>
                  <div class="body" v-if="progressCnt == 3">
                      <div class="header">An experiment on short-term memory (Baddeley 1966)</div>
                      <div class="target">
                          <p>Baddeley presented two different types of words to his participants.</p>
                          <p>Those that sounded the same (acoustically similar) and those that sounded different (acoustically dissimilar).</p>
                          <p>Baddeley also used two other lists of words with similar and dissimilar meanings, but they were used to test long-term memory.</p>
                      </div>
                      <div class="footer">
                          <button class="btn btn-target float-left" @click="btnGameBack">BACK</button>
                          <button class="btn btn-target" @click="btnGame">NEXT</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import JQuery from 'jquery';
import BarChart from './Chart.vue'

let $ = JQuery;

export default {
  name: "app",
  components: { BarChart },
  data() {
    return {
      progressCnt: 0,
      progressMax: 23,
      showDBox: true,
      showDGame: false,
      boxBtnText: 'START',
      checkbox1: [],
      checkbox2: [],
      audio: null,
      similarDataAudio: ['','','','','','','','','','',],
      differenceDataAudio: ['','','','','','','','','','',],
      similarDataVisual: ['','','','','','','','','',''],
      differenceDataVisual: ['','','','','','','','','','',],
      datacollection: null,
      maxScore: 100,
      synth : window.speechSynthesis,
      btnShow: true,
      confident: 'You are very confident in your ability to remember telephone numbers!',
      listenCarefully: 'Listen carefully',
    }
  },
  created() {
    this._box();
     $(document).ready(function(){
          setTimeout(() => {
            this.synth = window.speechSynthesis
          }, 1000);
      });
    
  },
  methods: {
    _box() {
      $(document).ready(function(){
        var p = this;
        var main = $(".d-cont");
        main.removeClass("d-scroll");
        var box = $(".d-box");
        if (main.outerHeight() <= (box.outerHeight() + 40 + 80) || main.outerWidth() <= (box.outerWidth() + 40 + 80)){
            main.addClass("d-scroll");
        }else{
            main.removeClass("d-scroll");
        }
      });
    },
    btnBox() {
      $(document).ready(function(){
          $('.d-scroll').scrollTop(0);
      });
      this.progressCnt++;
      this.playAudio();
      
    },
    playAudio() {
        this.listenCarefully = 'Listen carefully';
        switch (this.progressCnt) {
            case 1:
                this.showDBox = false;
                this.showDGame = true;
            break;
            case 5:
                // this.audio = new Audio(require('./assets/sounds/5_Words1.mp3'));
                // this.audio.play();
                this.speak('can, cad, mat, cap, max');
                this.btnShow = false;
            break;
            case 7:
                // this.audio = new Audio(require('./assets/sounds/4_Words2.mp3'));
                // this.audio.play();
                this.speak('rig, pen, few, bar, pit');
                this.btnShow = false;
            break;
            case 9:
                // this.audio = new Audio(require('./assets/sounds/3_Words3.mp3'));
                // this.audio.play();
                this.speak('man, max, cat, mat, cad');
                this.btnShow = false;
            break;
            case 11:
                // this.audio = new Audio(require('./assets/sounds/2_Words4.mp3'));
                // this.audio.play();
                this.speak('pit, say, pen, pin, few');
                this.btnShow = false;
            break;
            case 22:
                this.fillData();
                this.boxBtnText = 'NEXT';
            break;
            case 23:
                this.boxBtnText = 'TRY AGAIN';
            break;
            case 24:
                this.progressCnt = 0
                this.showDBox = true
                this.showDGame = false
                this.boxBtnText = 'START'
                this.checkbox1 = []
                this.checkbox2 = []
                this.audio = null
                this.similarDataAudio = ['','','','','','','','','','']
                this.differenceDataAudio = ['','','','','','','','','','']
                this.similarDataVisual = ['','','','','','','','','','']
                this.differenceDataVisual =  ['','','','','','','','','','']
                this.datacollection = null
                this.maxScore = 100
                this.btnShow = true;
            break;
            default:
                // if(this.audio != null){
                //   this.audio.pause();
                //   this.audio.currentTime = 0;
                //   this.audio = null;
                // }
            break;
        }
    },
    btnGame() {
      $(document).ready(function(){
          $('.d-scroll').scrollTop(0);
      });
      this.progressCnt++;
      if(this.progressCnt == 2){
          if(this.checkbox1[0] == true && this.checkbox2[1] == true ){ // high and low
              this.confident = 'You are like most people - you would remember information that is important to you.';
          }else if(this.checkbox1[0] == true && this.checkbox2[0] == true ){ //both high
              this.confident = 'You are very confident in your ability to remember telephone numbers!';
          }else if(this.checkbox1[1] == true && this.checkbox2[1] == true ){ //both low
              this.confident = 'You are not very confident in your ability to remember telephone numbers!';
          }else if(this.checkbox1[1] == true && this.checkbox2[0] == true ){ //both low
              this.confident = 'You are a very loyal member of your household, that you would remember the telephone number more important to them than to you.';
          }
      }

      if(this.progressCnt == 4){
          this.showDBox = true;
          this.showDGame = false;
          this.boxBtnText = "NEXT";
      }
    },
    btnGameBack() {
      $(document).ready(function(){
          $('.d-scroll').scrollTop(0);
      });
      this.progressCnt--;
      if(this.progressCnt == 3){
          this.showDBox = false;
          this.showDGame = true;
          this.boxBtnText = "NEXT";
      }
      if(this.progressCnt == 4){
          this.showDBox = true;
          this.showDGame = false;
          this.boxBtnText = "NEXT";
      }
      if(this.progressCnt == 0){
          this.showDBox = true;
          this.showDGame = false;
          this.boxBtnText = "START";
      }
      this.playAudio();
    },
    btnTest() {
    //   var audio = new Audio(require('./assets/sounds/6_Testing.mp3'));
    //   audio.play();
        this.speak('testing testing, 1 2 3');
    },
    fillData () {
      var similarScore = [0,0];
      var differenceScore = [0,0];

      similarScore[0] += this.similarDataAudio[0].trim() == 'can' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[1].trim() == 'cad' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[2].trim() == 'mat' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[3].trim() == 'cap' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[4].trim() == 'max' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[5].trim() == 'man' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[6].trim() == 'max' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[7].trim() == 'cat' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[8].trim() == 'mat' ? 10 : 0;
      similarScore[0] += this.similarDataAudio[9].trim() == 'cad' ? 10 : 0;

      differenceScore[0] += this.differenceDataAudio[0].trim() == 'rig' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[1].trim() == 'pen' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[2].trim() == 'few' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[3].trim() == 'bar' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[4].trim() == 'pit' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[5].trim() == 'pit' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[6].trim() == 'say' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[7].trim() == 'pen' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[8].trim() == 'pin' ? 10 : 0;
      differenceScore[0] += this.differenceDataAudio[9].trim() == 'few' ? 10 : 0;

      similarScore[1] += this.similarDataVisual[0].trim() == 'cad' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[1].trim() == 'cap' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[2].trim() == 'cab' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[3].trim() == 'can' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[4].trim() == 'max' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[5].trim() == 'cad' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[6].trim() == 'map' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[7].trim() == 'max' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[8].trim() == 'cab' ? 10 : 0;
      similarScore[1] += this.similarDataVisual[9].trim() == 'can' ? 10 : 0;

      differenceScore[1] += this.differenceDataVisual[0].trim() == 'pit' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[1].trim() == 'few' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[2].trim() == 'bar' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[3].trim() == 'cow' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[4].trim() == 'sup' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[5].trim() == 'rig' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[6].trim() == 'few' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[7].trim() == 'hot' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[8].trim() == 'pen' ? 10 : 0;
      differenceScore[1] += this.differenceDataVisual[9].trim() == 'pit' ? 10 : 0;

      var arraymerge = similarScore.concat(differenceScore);
      this.maxScore = Math.max.apply(null, arraymerge);

      this.datacollection = {
        labels: ['Acoustic', 'Visual'],
        datasets: [
          {
            label: 'Similar',
            backgroundColor: '#a2a2a2',
            data: similarScore
          }, {
            label: 'Different',
            backgroundColor: '#4c4c4c',
            data: differenceScore
          }
        ]
      }
    },
    speak (message) {
        var msg = new SpeechSynthesisUtterance(message)
        msg.rate = 0.7
        msg.lang = 'en-UK'
        this.synth.speak(msg)
        msg.onend = (event) => {
            this.btnShow = true;
            this.listenCarefully = 'Please click NEXT';
        }
    }
  },
};
</script>

<style>
html,body{
    padding:0px;
    margin:0px;
    height:100%;
    width:100%;
    overflow:hidden;
    font-size:20px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
}
body{
    color:black;
}

.d-cont{
    
    width: 100%;
    height: 100%;
    max-width: 1200px;
    max-height: 800px;
    position: absolute;
    transform: translate(-50%,-50%);
    left: 50%;
    top: 50%;
    overflow:auto;
}
.d-cont > .body{
    position:relative;
    width:100%;
    height:100%;
}

.d-box{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-box > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-box > .body > .content{
    position: relative;
    padding: 20px;
    border: 5px solid #000000;
    margin-bottom: 20px;
    color: #000000;
    border-radius: 10px;
}

.d-box > .body > .footer{
    text-align:right;
}

.d-box-canvas{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    width:98%;
    text-align:center;
}
.d-box-canvas > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-box-canvas > .body > .content{
    position: relative;
    border: 5px solid #000000;
    margin-bottom: 20px;
    color: #000000;
    border-radius: 10px;
}

.d-box-canvas > .body > .footer{
    text-align:right;
}

.btn, .btn:active, .btn:focus{
    background-color: #dddddd !important;
    -webkit-box-shadow: 0 0 0 0 rgba(0,123,255,.25) !important;
    box-shadow: 0 0 0 0 rgba(0,123,255,.25) !important;
}

.d-ins{
    font-size:20px;
    text-align:left;
}

.d-ins .ins-img{
    width:auto;
    height:100px;
    margin:0px 10px;
}

.d-chart-box{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-chart-box > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-chart-box > .body > .content, .d-chart-box > .body > .chart{
    position:relative;
    padding:20px;
    border:5px solid #000000;
    margin-bottom:20px;
    color:#000000;
    border-radius: 10px;
    text-align:left;
}
.d-chart-box > .body > .chart{
    min-height: 350px;
}
#chart3,#chart4{
    height:290px;
    width:100%;
}

.d-chart-box > .body > .footer{
    text-align:right;
}

canvas{
    margin-bottom:10px;
}

.d-game{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-game > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-game > .body > .header{
    position: relative;
    padding: 20px;
    border: 5px solid #000000;
    margin-bottom: 20px;
    border-radius: 10px;
    font-size: 23px;
    font-weight: 700;
}
.d-game > .body > .target{
    position:relative;
    padding:20px;
    border:5px solid #000000;
    margin-bottom:20px;
    border-radius: 10px;
    height:auto;
    max-height: 600px;
    text-align: left;
}
.d-game > .body > .target > .content{
    position:relative;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    height:100%;
    width:100%;
    padding:10px;
    max-width:500px;
    max-height:200px;
}

.d-game > .body > .target > .content > img{
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%); 
    max-width:100%;
    max-height:100%;   
}

.d-game > .body > .target .d-countdown{
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%,-50%);
    font-size: 25px;
    width: 100%;
    padding: 10px;
}
.d-game > .body > .target .d-countdown > .title{
    font-weight:500;
}
.d-game > .body > .target .d-countdown > .count{
    font-weight:700;
    font-size:30px;
}

.d-game > .body > .footer{ 
    text-align:right; 
}
/* .d-game > .body > .footer > button{
    min-width:200px;
}  */
.d-notify{
    position: fixed;
    width: 100%;
    font-size: 35px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-weight: 500;
}


.d-cont.d-scroll{
    max-height: unset;
    position: absolute;
    transform: translate(-50%,0%);
    top: 0px;
    overflow:auto;
    width: 100%;
    max-width: unset;
}
.d-cont.d-scroll > .body{
    padding:10px;
}

.d-cont.d-scroll .d-box{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}
.d-cont.d-scroll .d-game{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}
.d-cont.d-scroll .d-box-canvas{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}
.d-cont.d-scroll .d-chart-box{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}



.d-progress{
    border: none;
    position: fixed;
    top: 0px;
    width: 100%;
    height: 5px;
    z-index:9999;
    background: #86888b;
}

.d-progress::-webkit-progress-value {
  background: #86888b;
}

.d-progress::-moz-progress-bar {
  background: #86888b;
}
.d-progress::-webkit-progress-value {
  background: #86888b;
}
.d-progress::-webkit-progress-bar {
  background: #dddddd;
}

.d-header {
    position: fixed;
    top: 0px;
    font-size: 30px;
    font-weight: 700;
    background: black;
    width: 100%;
    color: white;
    padding: 10px;
    text-align: center;
    z-index: 9998;
}


.d-wrong{
    color:rgba(0,0,0,.5);
}



.browserCont{
    position:relative;
    width:100%;
    text-align:center;
    margin:20px 0px;
}
.browserCont > .browser{
    position:relative;
    width:50px;
    height:auto;
    margin:10px;
}
.browserCont > .browser > img{
    width:50px;
    height:auto;
}


.con-listen {
  min-height: 550px;
}

.con-listen > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.my-textbox {
    max-width: 150px;
    margin-right: 5px;
    border: 1px solid #cecece;
}


@media only screen and (max-width: 1000px) {
    .d-ins .ins-img{
        width:auto;
        height:80px;
        margin:0px 5px;
    }  
    
    .d-game > .body > .header{
        padding: 10px;
        border: 5px solid #000000;
        margin-bottom: 10px;
        border-radius: 10px;
        font-size: 20px;
    }    
    .d-game > .body > .target {
        padding: 10px;
        border: 5px solid #000000;
        margin-bottom: 10px;
        max-height: unset;
    }   
    
}

@media only screen and (max-width: 600px) {
    .con-listen {
        min-height: 250px;
    }
}

@media only screen and (max-width: 580px) {
    .d-header {
        font-size: 0.9rem;
    }
    .content > h1 {
        font-size: 1.5rem;
    }
    .body > .header {
        font-size: 0.9rem;
    }
    .body > .target {
        font-size: 0.8rem;
    }
    .content > p {
        font-size: 0.8rem;
    }
}


</style>


